import {
  GET_CUSTOMER_LIST, CHANGE_CUSTOMER_STATUS, GET_A_CUSTOMER, GET_CUSTOMER_HISTORY, GET_TEMP_CUSTOMER, GET_GROUP_LIST,
  GET_A_GROUP_DETAIL, GET_CHART_INFO, GET_A_DELETE_GROUP_DETAIL, UPDATE_CUSTOMER_GROUP, UPDATE_CUSTOMER_GROUP_STATUS, GET_CUSTOMER_CALLING_INFO,
  GET_SMS_TEMPLATE
} from "./customerListTypes";
import { Customer } from "../../models/customer";
import { Group } from "../../models/group";
import { CustomerHistory } from "../../models/customer_history";

export default {
  [GET_CUSTOMER_LIST](state, data) {
    state.customerData = data;
    let customer_arr = [];
    for (let i = 0; i < data.items.length; i++) {
      customer_arr.push(new Customer(data.items[i]));
    }
    state.customerList = customer_arr;
  },

  [CHANGE_CUSTOMER_STATUS](state, data) {
    for (let i = 0; i < state.customerList.length; i++) {
      if (state.customerList[i].id == data.customer.id) {
        state.customerList[i].changeStatus(data.status);
        return;
      }
    }
  },

  [GET_A_CUSTOMER](state, data) {
    state.customerInfo = data;
    for (let i = 0; i < state.groupList.length; i++) {
      state.groupList[i].changeStatusFalse();
    }
    for (let i = 0; i < data.groups.length; i++) {
      for (let j = 0; j < state.groupList.length; j++) {
        if (data.groups[i].group_id == state.groupList[j].id) {
          state.groupList[j].changeStatusInCurrentCustomer();
          break;
        }
      }
    }
  },

  [UPDATE_CUSTOMER_GROUP_STATUS](state) {
    if (state.groupList && state.groupList.length) {
      for (let i = 0; i < state.groupList.length; i++) {
        state.groupList[i].changeStatusFalse();
      }
    }
    if (state.customerInfo && state.customerInfo.groups && state.customerInfo.groups.length) {
      for (let i = 0; i < state.customerInfo.groups.length; i++) {
        for (let j = 0; j < state.groupList.length; j++) {
          if (state.customerInfo.groups[i].group_id == state.groupList[j].id) {
            state.groupList[j].changeStatusInCurrentCustomer();
            break;
          }
        }
      }
    }
  },

  [GET_CUSTOMER_HISTORY](state, data) {
    state.customerHistoryData = data;
    let history_arr = [];
    for (let i = 0; i < data.items.length; i++) {
      history_arr.push(new CustomerHistory(data.items[i]));
    }
    state.customerHistory = history_arr;
  },

  [GET_TEMP_CUSTOMER](state, data) {
    state.tempCustomer = data;
  },

  [UPDATE_CUSTOMER_GROUP](state, data) {
    state.customerGroup = data;
  },

  [GET_GROUP_LIST](state, data) {
    state.groupData = data;
    let group_arr = [];
    for (let i = 0; i < data.items.length; i++) {
      group_arr.push(new Group(data.items[i]));
    }
    state.groupList = group_arr;
  },

  [GET_A_GROUP_DETAIL](state, data) {
    state.groupInfo = data;

    let member_arr = [];
    for (let i = 0; i < data.items.length; i++) {
      member_arr.push(new Customer(data.items[i].customer));
    }
    state.groupMember = member_arr;
  },

  [GET_A_DELETE_GROUP_DETAIL](state, data) {
    state.deleteGroupInfo = data;

    let member_arr = [];
    for (let i = 0; i < data.items.length; i++) {
      member_arr.push(new Customer(data.items[i].customer));
    }
    state.deleteGroupMember = member_arr;
  },

  [GET_CHART_INFO](state, data) {
    state.chartInfo = data;
  },

  [GET_CUSTOMER_CALLING_INFO](state, data) {
    state.customerCallingInfo = data;
  },

  [GET_SMS_TEMPLATE](state, data) {
    state.smsCallTemplate = data;
  }
}
